import { Button } from "primereact/button"
import styles from "../../../styles/Participant-Employment.module.css"
const ViewHeader = ({ viewMode, title, closeViewMode }) => {
  return (
    <div className={styles.viewHeaderContainer}>
      {viewMode?.view && (
        <>
          <Button
            label={"Back"}
            className={styles.viewBackBtn}
            iconPos="left"
            icon="pi pi-angle-left"
            onClick={() => {
              closeViewMode()
            }}
          />
          <span className={styles.viewHeaderSeparator}>|</span>
        </>
      )}
      <h3 className={styles.view_subtitle} style={{ color: "#383838" }}>
        {title}
      </h3>
    </div>
  )
}
export default ViewHeader
